import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@/lib/legalLinks";

export function Footer({ onSignup }: { onSignup: () => void }) {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-[color:var(--line)] bg-white">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="rounded-3xl border border-[color:var(--line2)] bg-[color:var(--card-bg)] px-8 py-12 text-center shadow-[0_30px_60px_-40px_rgba(23,26,29,0.22)]">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[color:var(--ink)]">
            {t("footer.heading")}
          </h2>
          <button
            type="button"
            onClick={onSignup}
            className="cta mt-7 inline-flex items-center rounded-full px-7 py-3 text-sm font-semibold"
          >
            {t("footer.cta")}
          </button>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 text-sm text-[color:var(--muted-ink)] sm:flex-row">
          <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
          <div className="flex items-center gap-5">
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[color:var(--body)]"
            >
              {t("footer.privacy")}
            </a>
            {/* Absolute for the same reason as the privacy link above: Google's
                reviewer follows it from the homepage and matches it against the
                URL registered on the consent screen. */}
            <a
              href={TERMS_OF_SERVICE_URL}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[color:var(--body)]"
            >
              {t("footer.terms")}
            </a>
            <Link to="/cookies" className="hover:text-[color:var(--body)]">
              {t("footer.cookies")}
            </Link>
            <span className="font-display text-[color:var(--line2)]">
              {t("footer.tagline")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
